<template>
  <v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <form>
                <v-layout row>
                  <v-flex xs12>
                      <div class='text-md-center'>
                        <v-avatar size = 200> 
                           <img :src= this.photoURL alt="avatar">
                        </v-avatar>
                      </div>
                  </v-flex>
                </v-layout>
                <br>
                <hr>
                <br>
                <v-layout row>
                  <v-flex xs12><div class='text-md-center'>
                      
                        <input type="file" id="selectedFile" accept = "image/jpeg, image/png" style="display: none;" v-on:change="imageSelected"/>
                        <input type="button" value="Select a new profile image" onclick="document.getElementById('selectedFile').click();" />
                      </div>
                  </v-flex>
                </v-layout>
                <br>
                <hr>
                <br>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="name"
                      label="Name"
                      id="name"
                      v-model="name"
                      type="text"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="bio"
                      label="Tell us a little about yourself"
                      id="bio"
                      v-model="bio"
                      type="bio"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="title"
                      label="Job Title"
                      id="title"
                      v-model="title"
                      type="title"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="org"
                      label="Organization"
                      id="org"
                      v-model="organization"
                      type="org"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <div class="text-xs-center">
                      <v-btn round color="primary" :disabled="loading" :loading="loading" @click = 'confirmChanges'>Confirm Changes</v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      id: this.$store.getters.user.id,
      name: this.$store.getters.user.name,
      email: this.$store.getters.user.email,
      photoURL: this.$store.getters.user.photoURL,
      bio: this.$store.getters.user.bio,
      contacts: this.$store.getters.user.contacts,
      file: null,
      title: this.$store.getters.user.title,
      organization: this.$store.getters.user.organization,
      projects: this.$store.getters.user.projects
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    confirmChanges () {
      let user = {id: this.id, name: this.name, email: this.email, photoURL: this.photoURL, bio: this.bio, contacts: this.contacts, title: this.title, organization: this.organization}
      this.$store.dispatch('editProfile', {user, file: this.file})
      this.$router.push('/profile/' + user.id)
    },
    imageSelected (e) {
      this.file = e.target.files[0]
    }
  }
}
</script>


// WEBPACK FOOTER //
// EditProfile.vue?d368feac